import { render, staticRenderFns } from "./LoggedInUser.vue?vue&type=template&id=01510868&"
import script from "./LoggedInUser.vue?vue&type=script&lang=js&"
export * from "./LoggedInUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01510868')) {
      api.createRecord('01510868', component.options)
    } else {
      api.reload('01510868', component.options)
    }
    module.hot.accept("./LoggedInUser.vue?vue&type=template&id=01510868&", function () {
      api.rerender('01510868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/LoggedInUser.vue"
export default component.exports